<template>
    <rkm-overlay>
        <template>
            <rkm-layout-body title="Fila de atendimento">
                <template v-slot:actions>
                    <rkm-button
                        @click="$refs.ModalRecepcao.open()"
                        authorize="store-farmacia-fila-atendimento"
                        color="primary"
                    >
                        Adicionar paciente na lista
                    </rkm-button>
                </template>

                <rkm-layout-content>
                    <List />
                </rkm-layout-content>

                <ModalRecepcao ref="ModalRecepcao" />
            </rkm-layout-body>
        </template>
    </rkm-overlay>
</template>

<script>
// Components.
import List from '@/components/farmacia/fila-atendimento/List'
import ModalRecepcao from '@/components/farmacia/fila-atendimento/components/recepcao/Modal'

export default {
    components: {
        List,
        ModalRecepcao,
    },
}
</script>